import { buildApiCall } from '@he-novation/config/apis/api-fetch';
import { API_HUBSPOT } from '@he-novation/config/apis/hubspot-api';

export const asyncFetchHubspotIdentificationParams = async () =>
    buildApiCall(API_HUBSPOT.GET_ID_TOKEN)({});
